import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .direct-group-layout {
      display: grid;
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .no-groups-header {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .no-groups-body {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .groups {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .no-groups-body .description {
      padding-bottom: calc(40rem / var(--default-rem-px-count));
    }

    .input-prompt {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
    }

    .input-prompt .submit-input-wrapper {
      height: 100%;
    }

    .submit-input-wrapper {
      display: flex;
      flex-direction: row;
      gap: calc(20rem / var(--default-rem-px-count));
    }

    .submit-input-wrapper > input {
      padding: 0;
      line-height: calc(40rem / var(--default-rem-px-count));
      text-indent: calc(10rem / var(--default-rem-px-count));
    }

    .groups-list {
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      gap: calc(20rem / var(--default-rem-px-count));
    }

    .groups-list > .group-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      cursor: pointer;
      min-height: calc(150rem / var(--default-rem-px-count));
    }

    .group-wrapper img {
      padding: calc(10rem / var(--default-rem-px-count));
      max-width: -webkit-fill-available;
      max-width: -moz-available;
    }

    /* Override browser defaults */
    input {
      -webkit-appearance: none;
      outline: none;
      box-shadow: none;
      border: none;
      padding: 0;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
    }

    input {
      border: 1px solid;
      display: block;
      padding-left: calc(12rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .direct-group-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .no-groups-header {
        grid-column: 2 / 6;
        grid-row: 2;
      }

      .no-groups-body {
        grid-column: 7 / 14;
        grid-row: 2;
      }

      .groups {
        grid-column: 2 / 14;
        grid-row: 2;
        display: flex;
        flex-direction: column;
      }

      .groups-heading {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #ccc;
        padding-bottom: calc(40rem / var(--default-rem-px-count));
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .group-code {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: calc(20rem / var(--default-rem-px-count));
      }

      .group-code > input,
      .input-prompt > input {
        min-height: 100%;
      }

      .groups-list {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      .groups-list > .group-wrapper {
        min-height: calc(200rem / var(--default-rem-px-count));
      }

      cta-button {
        width: calc(200rem / var(--default-rem-px-count));
      }
    }
  `,
];
